<div class="container mt-5">
    <div class="row" *ngIf="isProyectos">
        <div class="col-12 text-center">
            <button class="btn btn-primary" (click)="general = true; visible = true">Nuevo evento general</button>
        </div>
    </div>
    <app-subtitle-hr [title]="'Mi calendario'"></app-subtitle-hr>
    <div class="card">
        <div class="card-header" style="font-size: 1.2rem">
            <div class="row">
                <div class="col-6 text-start"></div>
                <div class="col-6 text-end">
                    <button class="btn btn-primary" (click)="visible = true">Nuevo evento personal</button>
                </div>
            </div>
        </div>
        <div class="card-body" style="overflow: auto;">
            <div class="elemento" style="width: 100%;">
                <app-calendario />
            </div>
        </div>
    </div>
</div>

<!-- Diálogo para carga de nuevo recordatorio -->
<p-dialog header="Edit Profile" [modal]="true" [(visible)]="visible" [draggable]="false" [style]="{'width': '80vw'}"
    (onHide)="hide()">
    <ng-template pTemplate="header">
        <h5 class="m-2"><i class="pi pi-calendar-plus"></i>
            {{ general ? 'Actividades generales' : 'Crear evento personal'}}</h5>
        <ng-container *ngIf="general">
            <p class="m-2"><small><b>Estas actividades se reflejaran en las agendas de los usuario de
                        Proyectos.</b></small>
            </p>
        </ng-container>

    </ng-template>
    <div class="row pt-4">
        <div class="col-9">
            <span class="p-float-label">
                <input pInputText id="title" [(ngModel)]="title" style="width: 100%" />
                <label for="title">Título</label>
            </span>
        </div>
        <div class="col-3 flex justify-content-center align-items-center">
            <p-colorPicker [(ngModel)]="color" />
        </div>

        <div class="col-12">
            <span class="p-float-label">
                <input pInputText id="desc" [(ngModel)]="desc" style="width: 100%" />
                <label for="desc">Descripción</label>
            </span>
        </div>
        <div class="col-12 text-end">
            <p-checkbox [binary]="true" [label]="'Todo el día'" [(ngModel)]="allDay"></p-checkbox>
        </div>
        <div class="col-6">
            <span class="p-float-label">
                <p-calendar [(ngModel)]="desde" inputId="calendar-24h" [showTime]="!allDay" [hourFormat]="'24'"
                    [style]="{width:'100%'}" appendTo="body" [showIcon]="true"></p-calendar>
                <label for="date">Inicio</label>
            </span>
        </div>
        <div class="col-6">
            <span class="p-float-label" *ngIf="!allDay">
                <p-calendar [(ngModel)]="hasta" inputId="calendar-24h" [showTime]="!allDay" [hourFormat]="'24'"
                    [style]="{width:'100%'}" appendTo="body" [showIcon]="true"></p-calendar>
                <label for="date">Fin</label>
            </span>
        </div>
        <div class="col-12">
            <p-dropdown [options]="recordatorio" [(ngModel)]="selectedRecordatorio" [showClear]="true"
                placeholder="Fecha recordatorio" [style]="{width:'100%'}" appendTo="body" (ngModelChange)="mostrar()" />
        </div>
        <div class="col-12" *ngIf="showRec">
            <span class="p-float-label">
                <p-calendar [(ngModel)]="rec" inputId="date" [style]="{width:'100%'}" appendTo="body"
                    [showIcon]="true"></p-calendar>
                <label for="date">Fin</label>
            </span>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <div class="row text-end">
            <div class="col-12">
                <button class="btn btn-primary" (click)="onInsert(dialog)">Cargar</button>
            </div>
        </div>
    </ng-template>
</p-dialog>

<app-dialog #dialog />

<app-back-button routerLink=".." />